export const superAdminAndFounderOptions = [
    { id: "yes", value: true },
    { id: "no", value: false }
];
